import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 获取类目树
  static getMenuList(params) {
    return request({
      url: 'tradecore/faster/shopping/list/catalog/tree',
      host: config.HOST_MALL,
      params
    });
  }

  // 根据类目id,获取产品列表
  static getProductList(params) {
    return request({
      url: 'tradecore/promotion/list/item',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  // 根据类目id,获取产品列表
  static getCategoryProductList(params) {
    return request({
      url: 'promotion/activity/item',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 关键词搜索资格购商品列表
   */
  static searchQualification(params, filterValue) {
    return request({
      url:
        'promotion/queryActiveActivity/qualification/item/welfareMall?filterValue=' + filterValue,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  // 获取产品列表
  static getProductData(params) {
    return request({
      url: 'user/register/listCatalogAndItemByCardTypeId',
      host: config.HOST_MALL,
      params
    });
  }

  // 获取产品详情
  static getProductDetail(params) {
    return request({
      url: 'user/register/queryItemExtListByParentId',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  // 结算
  static confirmOrder(params) {
    return request({
      url: 'user/register/confirmRegisterCardOrder',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  static getOrderList(params) {
    return request({
      url: 'user/register/queryBenefitList',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取已选产品列表
   */
  static getSelectedProducts(
    data,
    orderType,
    distributionRatio,
    cardNo,
    discount,
    showFlag,
    leftClassify,
    saleMode
  ) {
    showFlag = showFlag == 'true' ? 1 : 0;
    let url = cardNo
      ? `tradecore/faster/shopping/promotion/item/dglist/${orderType}/${distributionRatio}/${cardNo}?disableTag=${showFlag}`
      : `tradecore/faster/shopping/promotion/item/list/${orderType}/${distributionRatio}?disableTag=${showFlag}`;
    const { id } = Object.fromEntries(new URLSearchParams(window.location.href.split('?')[1]));
    if (['1311273896686821380', '1310008182922384431'].includes(id)) {
      url = `tradecore/faster/shopping/promotion/item/list/birthday`;
    }
    // http://mallapi.uat.yofoys.cn/biz-mall-application/v1/tradecore/faster/shopping/promotion/item/list/birthday
    if (discount) {
      url += `?discount=${discount}`;
    }

    if (saleMode) {
      url = `${url}${url.indexOf('?') >= 0 ? '&' : '?'}saleMode=${saleMode}`;
    }

    if (
      !['1311273896686821380', '1310008182922384431'].includes(id) &&
      [0, 2].includes(leftClassify) &&
      id
    ) {
      url += `&qualificationId=${id}`;
    }

    return request({
      url,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 批量计算活动分组的优惠金额
   */
  static getDiscountBatch(data) {
    return request({
      url: data.dgCardno
        ? 'tradecore/faster/shopping/calculate/discount/batch/dgQuery'
        : `tradecore/trolley/calculate/discount/batch/query`,
      host: config.HOST_MALL,
      method: 'post_json',
      data,
      ignoreErr: true
    });
  }

  /**
   * 去凑单，获取活动产品列表
   */
  static getActivityProductList(data) {
    return request({
      url: data.dgCardno
        ? 'tradecore/faster/shopping/activiy/gifts/item/dglist'
        : `tradecore/trolley/activiy/gifts/item/list`,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true,
      data
    });
  }

  /**
   * 查询对应活动ids的赠品列表
   */
  static getActivityIdsGiftList(params) {
    return request({
      url: `tradecore/promotion/activity/gift/list/batch`,
      host: config.HOST_MALL,
      data: params,
      method: 'post_json'
    });
  }

  /**
   * 代客下单，获取店铺支持的配货比例
   */
  static getDistriBution(params) {
    return request({
      url: 'biz/tradecore/trade/query/distribution-rate',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取折扣信息
   */
  static getDiscountList(params) {
    return request({
      url: `discount/query/discount`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 查询对应活动id的赠品列表
   */
  static getActivityGiftList(params) {
    return request({
      url: `tradecore/promotion/activity/gift/list`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 查询资格购活动列表
   */
  static getQualificationList(data) {
    return request({
      url: 'promotion/queryActiveActivity/qualification/validate',
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 获取加价购信息
   */
  static getIncPriceShopMsg(data) {
    return request({
      url: `tradecore/trolley/activity/additional/item/list`,
      host: config.HOST_MALL,
      method: 'post_json',
      data,
      ignoreErr: true
    });
  }

  /**
   * 查询商品列表
   */
  static getZiGeProductList(id, params) {
    return request({
      url: `promotion/activity/id/${id}`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取活动信息
   */
  static getActivityInfo(activityId) {
    return request({
      url: `promotion/activity/id/${activityId}`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  /**
   * 校验有无活动资格
   */
  static checkActivity(params) {
    return request({
      url: `promotion/query/activity/validateById`,
      host: config.HOST_MALL,
      params,
      ignoreErr: true
    });
  }

  /**
   * 获取卡级别
   */
  static getCardList() {
    return request({
      url: 'cardType/link/progress',
      host: config.HOST_MALL
    });
  }

  /**
   * 获取客卡级别
   */
  static getDgCardList(params) {
    return request({
      url: `cardType/refreshCrowSystem/link/progress`,
      host: config.HOST_STORE,
      params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/TradeManage/QuickBuyForCoupon/QuickBuyServ.js